var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 5,
    fill: "#916DE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.156 27.8846C14.0209 28.0205 13.8603 28.1283 13.6833 28.2019C13.5064 28.2755 13.3166 28.3134 13.125 28.3134C12.9334 28.3134 12.7436 28.2755 12.5667 28.2019C12.3897 28.1283 12.2291 28.0205 12.0939 27.8846L3.8602 19.6494C3.4501 19.2392 3.21973 18.6829 3.21973 18.1028C3.21973 17.5228 3.4501 16.9665 3.8602 16.5563L4.89124 15.5252C5.30146 15.1151 5.85775 14.8848 6.4378 14.8848C7.01785 14.8848 7.57415 15.1151 7.98436 15.5252L13.125 20.6659L27.0156 6.77524C27.4258 6.36514 27.9821 6.13477 28.5622 6.13477C29.1422 6.13477 29.6985 6.36514 30.1087 6.77524L31.1398 7.80628C31.5499 8.21649 31.7803 8.77279 31.7803 9.35284C31.7803 9.93289 31.5499 10.4892 31.1398 10.8994L14.156 27.8846Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.717fa729e9ec48bedd909fbe26aa8f38.svg";
export { ForwardRef as ReactComponent };